import {
  TFlamingoOrderBookTokens,
  TFlamingoOrderBookTradingPair,
} from '@/libs/flamingo-orderbook/types'

export const FLAMING_ORDER_BOOK_TRADING_PAIRS: TFlamingoOrderBookTradingPair[] = [
  {
    key: 'GM_FUSD',
    ticker: 'GM/FUSD',
    pairId: 1,
    poolHash: '0x43794acaca6cc28736c4eea63a6939de53c32e53',
    extra: {
      maxPriceDecimals: 6,
      maxVolumeDecimals: 4,
      priceIntervals: ['0.000001'],
    },
  },
  {
    key: 'BNEO_FLM',
    ticker: 'bNEO/FLM',
    pairId: 2,
    poolHash: '0x4d5a85b0c83777df72cfb665a933970e4e20c0ec',
    extra: {
      maxPriceDecimals: 0,
      maxVolumeDecimals: 2,
      priceIntervals: ['1'],
    },
  },
  {
    key: 'FLM_WBTC',
    ticker: 'FLM/WBTC',
    pairId: 3,
    poolHash: '0x73eab0fdd097c3b37aabeee37946458cfe2e523e',
    extra: {
      maxPriceDecimals: 8,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.00000001'],
    },
  },
  {
    key: 'FLM_FUSD',
    ticker: 'FLM/FUSD',
    pairId: 4,
    poolHash: '0xaeae872ace15f87c117213c92c00944af789aed2',
    extra: {
      maxPriceDecimals: 4,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.0001'],
    },
  },
  {
    key: 'WETH_FUSD',
    ticker: 'WETH/FUSD',
    pairId: 5,
    poolHash: '0xb9f87cb4f741bc5dc299132fe1b8372f01d37ca4',
    extra: {
      maxPriceDecimals: 0,
      maxVolumeDecimals: 4,
      priceIntervals: ['10'],
    },
  },
  {
    key: 'SWTH_FUSD',
    ticker: 'SWTH/FUSD',
    pairId: 6,
    poolHash: '0x23a16fd44773cc51f404d92fc6a26a81d3918a08',
    extra: {
      maxPriceDecimals: 5,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.00001'],
    },
  },
  {
    key: 'ONT_FUSD',
    ticker: 'ONT/FUSD',
    pairId: 7,
    poolHash: '0xde1908bbcfa2aabf2727d241fa306bb668ebb35e',
    extra: {
      maxPriceDecimals: 3,
      maxVolumeDecimals: 1,
      priceIntervals: ['0.001'],
    },
  },
  {
    key: 'BNB_FUSD',
    ticker: 'BNB/FUSD',
    pairId: 8,
    poolHash: '0xcfb958afaa82dc0923486524246bdad08ab9c6ae',
    extra: {
      maxPriceDecimals: 0,
      maxVolumeDecimals: 3,
      priceIntervals: ['1'],
    },
  },
  {
    key: 'CAKE_FUSD',
    ticker: 'CAKE/FUSD',
    pairId: 9,
    poolHash: '0x495bb94a16c321f82cf70fc0d1182340aa9387fe',
    extra: {
      maxPriceDecimals: 2,
      maxVolumeDecimals: 2,
      priceIntervals: ['0.01'],
    },
  },
  {
    key: 'WING_FUSD',
    ticker: 'WING/FUSD',
    pairId: 10,
    poolHash: '0xd849d138824190bcb3ec54b38de656760d2cd578',
    extra: {
      maxPriceDecimals: 2,
      maxVolumeDecimals: 2,
      priceIntervals: ['0.01'],
    },
  },
  {
    key: 'GAS_FUSD',
    ticker: 'GAS/FUSD',
    pairId: 11,
    poolHash: '0x2f6ef6baaf7a9129cf0edf364798e75d5ee5eaf0',
    extra: {
      maxPriceDecimals: 2,
      maxVolumeDecimals: 1,
      priceIntervals: ['0.01'],
    },
  },
  {
    key: 'WBTC_FUSD',
    ticker: 'WBTC/FUSD',
    pairId: 12,
    poolHash: '0xf7ba0fc88dd66dc39bfbaa7edefc255cd262b8df',
    extra: {
      maxPriceDecimals: 0,
      maxVolumeDecimals: 8,
      priceIntervals: ['10'],
    },
  },
  {
    key: 'FUSD_USDT',
    ticker: 'FUSD/USDT',
    pairId: 13,
    poolHash: '0x9ef4d5c1a686e13d72184b66e4bda77d7b4bae9f',
    extra: {
      maxPriceDecimals: 3,
      maxVolumeDecimals: 2,
      priceIntervals: ['0.001'],
    },
  },
  {
    key: 'FUSD_USDC',
    ticker: 'FUSD/USDC',
    pairId: 25,
    poolHash: '0x73145563232df26ea2e42f5d1877062ad603e033',
    extra: {
      maxPriceDecimals: 3,
      maxVolumeDecimals: 2,
      priceIntervals: ['0.001', '0.01'],
    },
  },
  {
    key: 'BNEO_FUSD',
    ticker: 'bNEO/FUSD',
    pairId: 14,
    poolHash: '0x3269ece5dc33adf17ed14be7780693f3c8b102d1',
    extra: {
      maxPriceDecimals: 1,
      maxVolumeDecimals: 1,
      priceIntervals: ['0.1'],
    },
  },
  {
    key: 'BNEO_GAS',
    ticker: 'bNEO/GAS',
    pairId: 15,
    poolHash: '0x3244fcadcccff190c329f7b3083e4da2af60fbce',
    extra: {
      maxPriceDecimals: 2,
      maxVolumeDecimals: 1,
      priceIntervals: ['0.01'],
    },
  },
  {
    key: 'NUDES_FUSD',
    ticker: 'NUDES/FUSD',
    pairId: 16,
    poolHash: '0xe0e75fcfbbeeffd289756592d0bb208227661a86',
    extra: {
      maxPriceDecimals: 12,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.000000000001'],
      disablePostOnly: !0,
    },
  },
  {
    key: 'FRANK_FUSD',
    ticker: 'FRANK/FUSD',
    pairId: 17,
    poolHash: '0x21a12c3b359af44636b1c5647e2684fef934cada',
    extra: {
      maxPriceDecimals: 3,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.001'],
    },
  },
  {
    key: 'NDMEME_FUSD',
    ticker: 'NDMEME/FUSD',
    pairId: 18,
    poolHash: '0x6ef8beae3586634426bbdd56f6bee310589889a3',
    extra: {
      maxPriceDecimals: 5,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.00001'],
    },
  },
  {
    key: 'FDE_FUSD',
    ticker: 'FDE/FUSD',
    pairId: 19,
    poolHash: '0x66d138dfd9506f0132983cd0d6ba731b65da48b9',
    extra: {
      maxPriceDecimals: 6,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.000001'],
    },
  },
  {
    key: 'SOM_FUSD',
    ticker: 'SOM/FUSD',
    pairId: 20,
    poolHash: '0x3860e44de972d7bef817a0840fa12b218c8fcb1f',
    extra: {
      maxPriceDecimals: 7,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.0000001'],
    },
  },
  {
    key: 'CANDY_FUSD',
    ticker: 'CANDY/FUSD',
    pairId: 21,
    poolHash: '0x323a153cd845781b1c580ec8139ae683272366c2',
    extra: {
      maxPriceDecimals: 7,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.0000001'],
    },
  },
  {
    key: 'APE_FUSD',
    ticker: 'APE/FUSD',
    pairId: 22,
    poolHash: '0xeec4e7563a3e4abd80ea61401df199c67009e5a8',
    extra: {
      maxPriceDecimals: 6,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.000001'],
    },
  },
  {
    key: 'NRP_FUSD',
    ticker: 'NRP/FUSD',
    pairId: 23,
    poolHash: '0x63547ac2dd843d1138f07c11fceaa085684d7797',
    extra: {
      maxPriceDecimals: 6,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.000001'],
    },
  },
  {
    key: 'FLOCKS_FLM',
    ticker: 'FLOCKS/FLM',
    pairId: 24,
    poolHash: null,
    extra: {
      maxPriceDecimals: 4,
      maxVolumeDecimals: 0,
      priceIntervals: ['0.0001'],
      disablePostOnly: !0,
    },
  },
]

export const FLAMINGO_ORDER_BOOK_TOKENS: TFlamingoOrderBookTokens = {
  FLM: {
    symbol: 'FLM',
    decimals: 8,
    hash: '0xf0151f528127558851b39c2cd8aa47da7418ab28',
    name: 'FLM',
  },
  FLOCKS: {
    symbol: 'FLOCKS',
    decimals: 8,
    hash: '0xdad88d8c8d4643548aa0f63c83796e81c3c6b04c',
    name: 'FLOCKS',
  },
  FUSD: {
    symbol: 'FUSD',
    decimals: 8,
    hash: '0x1005d400bcc2a56b7352f09e273be3f9933a5fb1',
    name: 'FUSD',
  },
  FLUND: {
    symbol: 'FLUND',
    decimals: 0,
    hash: '0xa9603a59e21d29e37ac39cf1b5f5abf5006b22a3',
    name: 'FLUND',
  },
  bNEO: {
    symbol: 'bNEO',
    decimals: 8,
    hash: '0x48c40d4666f93408be1bef038b6722404d9a4c2a',
    name: 'bNEO',
  },
  NEO: {
    symbol: 'NEO',
    decimals: 0,
    hash: '0xef4073a0f2b305a38ec4050e4d3d28bc40ea63f5',
    name: 'NEO',
  },
  GAS: {
    symbol: 'GAS',
    decimals: 8,
    hash: '0xd2a4cff31913016155e38e474a2c06d08be276cf',
    name: 'GAS',
  },
  USDT: {
    symbol: 'USDT',
    decimals: 6,
    hash: '0x68b938cc42b6a2d54fb9040f5facf4290ebb8c5f',
    name: 'USDT',
  },
  USDC: {
    symbol: 'USDC',
    decimals: 18,
    hash: '0x6627a4a0dfcb409bf1e0fb3e217441f3f9809fce',
    name: 'USDC',
  },
  WETH: {
    symbol: 'WETH',
    decimals: 18,
    hash: '0xd3a41b53888a733b549f5d4146e7a98d3285fa21',
    name: 'WETH',
  },
  WBTC: {
    symbol: 'WBTC',
    decimals: 8,
    hash: '0x4548a3bcb3c2b5ce42bf0559b1cf2f1ec97a51d0',
    name: 'WBTC',
  },
  ONT: {
    symbol: 'ONT',
    decimals: 9,
    hash: '0x0a1328bffb804ad7bb342673da82a972cc7af86c',
    name: 'ONT',
  },
  WINGv2: {
    symbol: 'WINGv2',
    decimals: 9,
    hash: '0x948a60635d1f7921063d04be8f6cb35c741df566',
    name: 'WING',
  },
  BNB: {
    symbol: 'BNB',
    decimals: 18,
    hash: '0x00fb9575f220727f71a1537f75e83af9387628ff',
    name: 'BNB',
  },
  CAKE: {
    symbol: 'CAKE',
    decimals: 18,
    hash: '0x570c27653683788177f05740257d88fed76bf74b',
    name: 'CAKE',
  },
  SWTH: {
    symbol: 'SWTH',
    decimals: 8,
    hash: '0x78e1330db47634afdb5ea455302ba2d12b8d549f',
    name: 'SWTH',
  },
  GM: {
    symbol: 'GM',
    decimals: 8,
    hash: '0x9b049f1283515eef1d3f6ac610e1595ed25ca3e9',
    name: 'GM',
  },
  NUDES: {
    symbol: 'NUDES',
    decimals: 8,
    hash: '0x340720c7107ef5721e44ed2ea8e314cce5c130fa',
    name: 'NUDES',
  },
  SOM: {
    symbol: 'SOM',
    decimals: 8,
    hash: '0x2d4c6cf0417209a7eb410160344e224e74f87195',
    name: 'SOM',
  },
  CANDY: {
    symbol: 'CANDY',
    decimals: 9,
    hash: '0x88da18a5bca86ec8206d9b4960a7d0c4355a432f',
    name: 'CANDY',
  },
  FDE: {
    symbol: 'FDE',
    decimals: 8,
    hash: '0x9770f4d78a19d1a6fa94b472bcedffcc06b56c49',
    name: 'FDE',
  },
  FRANK: {
    symbol: 'FRANK',
    decimals: 8,
    hash: '0xa06cfd7ae9dd7befb7bf8e5b8c5902c969182de0',
    name: 'FRANK',
  },
  HD: {
    symbol: 'HD',
    decimals: 8,
    hash: '0x4b027a8320d5705802e5efbb51f6231ebf412cf6',
    name: 'HD',
  },
  NDMEME: {
    symbol: 'NDMEME',
    decimals: 8,
    hash: '0x57d1761945697a2257be76b756dcc9c19b512ff1',
    name: 'NDMEME',
  },
  APE: {
    symbol: 'APE',
    name: 'APE',
    decimals: 8,
    hash: '0x63f1a9c6bef178f54a6332b874407068d9a99e50',
  },
  NRP: {
    symbol: 'NRP',
    name: 'NRP',
    decimals: 8,
    hash: '0x789518aa302b571e3e825f2c85a01ad731014a45',
  },
  fWBTC: {
    symbol: 'fWBTC',
    name: 'fWBTC',
    decimals: 8,
    hash: '0xd6abe115ecb75e1fa0b42f5e85934ce8c1ae2893',
  },
  fUSDT: {
    symbol: 'fUSDT',
    name: 'fUSDT',
    decimals: 6,
    hash: '0xcd48b160c1bbc9d74997b803b9a7ad50a4bef020',
  },
  fWETH: {
    symbol: 'fWETH',
    name: 'fWETH',
    decimals: 18,
    hash: '0xc14b601252aa5dfa6166cf35fe5ccd2e35f3fdf5',
  },
  fCAKE: {
    symbol: 'fCAKE',
    name: 'fCAKE',
    decimals: 18,
    hash: '0xe65b462b90516012826f8a9c4c285d8c750e3a77',
  },
  fBNB: {
    symbol: 'fBNB',
    name: 'fBNB',
    decimals: 18,
    hash: '0xb56f0fba45cc57a948b342186274dfd863996bb3',
  },
  pONT: {
    symbol: 'pONT',
    name: 'pONT',
    decimals: 9,
    hash: '0x8122bc2212ec971690a044b37a6f52a9349b702b',
  },
  WING: {
    symbol: 'WING',
    name: 'WING',
    decimals: 9,
    hash: '0xeeccd60ed722111f8400434dac3ba42c14d8beb1',
  },
  bNUDES: {
    symbol: 'bNUDES',
    name: 'TIPS',
    decimals: 8,
    hash: '0x301ff7c013ec7043ffb9453cd3fb32754ccaa1a5',
  },
  WONT: {
    symbol: 'WONT',
    name: 'WONT',
    decimals: 9,
    hash: '0x219CC8e994EA6B35CdCFFB5d44E229325D5aD02A',
  },
  LRB: {
    symbol: 'LRB',
    decimals: 8,
    hash: '0x8c07b4c9f5bc170a3922eac4f5bb7ef17b0acc8b',
    name: 'LRB',
  },
  DOGER: {
    symbol: 'DOGER',
    decimals: 8,
    hash: '0x322b5a366ca724801a1aa01e669b5f3d7f8c7f6f',
    name: 'DOGER',
  },
}
